// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import './common/css/common.css'
import './common/css/font/iconfont.css'
import animated from 'animate.css'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import common from './common/js/common.js'
import './common/css/font/iconfont.js'
//配置文件
import './common/js/plugIn.js'
//长连接和心跳函数
import './common/js/longConnect.js'
//自定义滚动条指令
import scrollBar from './common/js/directive'
//对应的css
import "perfect-scrollbar/css/perfect-scrollbar.css";
Vue.use(animated)
Vue.use(iView)
Vue.config.productionTip = false
//判断是否有AUTHORIZATION 没有跳转到首页
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否有直接进入的权限
      if (common.getCookie('Authorization')) { // 判断当前的token是否存在 ；
       next();
      }
      else {
       next({
        path: '/',
        query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
       })
      }
     }
     else {
      next();
     }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
})
//请求拦截器
axios.interceptors.response.use(
  response => {
      return response;
  },
  error => {
      if (error.response) {
          switch (error.response.status) {
              case 401:
              common.delCookie('userId');
              common.delCookie('type');
              common.delCookie('screenKey');
              common.delCookie('activityId');
              common.delCookie('ocId');
              common.delCookie('channel');
              common.delCookie('Authorization');
              iView.Message.error('无访问权限');
              // 返回 401 清除token信息并跳转到登录页面
              router.replace({
                  path: '/',
                  query: {redirect: router.currentRoute.fullPath}
              })
          }
      }
      return Promise.reject(error.response.data)   // 返回接口返回的错误信息
});
Vue.prototype.$http = axios
Vue.prototype.common = common
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js